import script from "./RequestUpdateModalForProductImages.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForProductImages.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForProductImages.vue?vue&type=style&index=0&id=e8b29464&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8b29464"]])

export default __exports__